import React, { useEffect, useState } from "react";

const AdBlockDetector: React.FC = () => {
  const [adBlockDetected, setAdBlockDetected] = useState<boolean>(false);

  useEffect(() => {
  const checkAdBlock = () => {
    const script = document.createElement("script");
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?cb=${Date.now()}`;
    script.async = true;

    script.onerror = () => {
      setAdBlockDetected(true);
    };

    script.onload = () => {
      setAdBlockDetected(false);
    };

    document.body.appendChild(script);

    setTimeout(() => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    }, 1000);
  };

  checkAdBlock();

  const interval = setInterval(() => {
    checkAdBlock();
  }, 10000);

  return () => clearInterval(interval);
}, []);


  if (!adBlockDetected) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.85)",
        color: "#fff",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
        textAlign: "center",
      }}
      aria-live="assertive"
      role="alert"
    >
      <h2 className="text-2xl font-semibold mb-4">Ad Blocker Detected</h2>
      <p className="mb-4 max-w-xl">
        Please disable your ad blocker to access this site. We rely on ads to keep the service free.
      </p>
      <p className="mb-4 max-w-xl">
        If you’ve already whitelisted this site and are still seeing this message, your ad blocker may be overly strict.
        Try turning off the ad blocker completely or allowing ads globally for this site.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="bg-white text-black px-6 py-2 rounded-md font-semibold hover:bg-gray-200 transition"
      >
        Reload Page
      </button>
    </div>
  );
};

export default AdBlockDetector;
